

















import { Component, Prop, Vue } from "vue-property-decorator";
import EntryListVariant from "@/components/EntryListVariant.vue";
import { Company, Brand, Product, ClientAgentProduct } from "@/models";
import ClientCompany from "@/models/Agents/Company";
import Entry from "@/models/Entry";

@Component({
  components: {
    EntryListVariant,
  },
})
export default class EntryListGroupVariant extends Vue {
  @Prop() items!: {
    companies?: Company[];
    brands?: Brand[];
    products?: Product[];
    clientCompanies?: ClientCompany[];
    clientProducts?: ClientAgentProduct[];
  };

  get showList() {
    return (
      (this.items.companies && this.items.companies.length) ||
      (this.items.clientCompanies && this.items.clientCompanies.length) ||
      (this.items.clientProducts && this.items.clientProducts.length)
    );
  }

  get itemsList() {
    if (this.items.companies && this.items.companies.length) {
      return this.items.companies;
    }
    if (this.items.clientCompanies && this.items.clientCompanies.length) {
      return this.items.clientCompanies;
    }
    if (this.items.clientProducts && this.items.clientProducts.length) {
      return this.items.clientProducts;
    }
    return [];
  }

  @Prop() readonly canAdd?: (item: Entry) => boolean;
  @Prop({ default: false }) readonly selectable?: boolean;
  @Prop({ default: true }) readonly actions?: boolean;
  @Prop({ default: true }) readonly showTitles?: boolean;
  @Prop() readonly size?: string;

  onAdd(value: Company | Brand | Product | ClientCompany | ClientAgentProduct) {
    this.$emit("add", value);
  }

  onRemove(
    value: Company | Brand | Product | ClientCompany | ClientAgentProduct
  ) {
    this.$emit("remove", value);
  }

  onSelected(
    value: Company | Brand | Product | ClientCompany | ClientAgentProduct
  ) {
    this.$emit("selected", value);
  }
}
